import { X } from 'lucide-react'
import ListWidget, { type ListWidgetRow } from './ListWidget'

/** Generic "who's behind this number" modal: a title, a row list (already
 * loaded, or still loading), and a close button. Shared by every clickable
 * stat tile / bar / table row across the admin dashboard and HR Analytics
 * pages so each one doesn't reimplement the same overlay. */
export default function DetailModal({
  title, rows, loading, onClose, emptyLabel,
}: {
  title: string
  rows: ListWidgetRow[]
  loading?: boolean
  onClose: () => void
  emptyLabel?: string
}) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="fixed inset-0 bg-black/40" />
      <div
        className="relative bg-white rounded-xl shadow-xl w-full max-w-md max-h-[80vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between border-b border-gray-100 px-5 py-3.5 shrink-0">
          <h2 className="text-sm font-semibold text-gray-900">{title}</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600"><X className="h-5 w-5" /></button>
        </div>
        <div className="flex-1 overflow-y-auto p-5">
          {loading ? (
            <p className="text-sm text-gray-400 text-center py-8">Loading…</p>
          ) : (
            <ListWidget rows={rows} emptyLabel={emptyLabel} />
          )}
        </div>
      </div>
    </div>
  )
}
